import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ManureSpaceApiService } from 'src/app/manure-space/services/manure-space-api.service';
import { setInitialStockMatchesRvo } from 'src/app/manure-space/store/manure-space.actions';
import * as ManureSpaceSelectors from 'src/app/manure-space/store/manure-space.selectors';
import { SiteState } from 'src/app/shared/models';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-initial-stock-rvo-check',
  templateUrl: './initial-stock-rvo-check.component.html',
  styleUrls: ['./initial-stock-rvo-check.component.scss'],
  imports: [MatCheckboxModule, SharedModule],
  standalone: true,
})
export class InitialStockRvoCheckComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly manureSpaceApi = inject(ManureSpaceApiService);
  private readonly destroyed$ = new Subject<boolean>();

  checked = false;
  disabled = false;
  private manureSpaceId: number;

  ngOnInit() {
    this.store
      .select(ManureSpaceSelectors.selectInitialStockMatchesRvo)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((initialStockMatchesRvo) => {
        this.checked = initialStockMatchesRvo;
      });

    this.store
      .select(ManureSpaceSelectors.selectActiveTabManureSpace)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((manureSpace) => {
        if (manureSpace?.state === 'loaded' && manureSpace.data) {
          this.manureSpaceId = manureSpace.data.id;
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onChange(initialStockMatchesRvo: boolean) {
    if (this.disabled) {
      return;
    }

    this.disabled = true;
    this.manureSpaceApi
      .postInitialStockMatchesRvo(this.manureSpaceId, initialStockMatchesRvo)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.checked = initialStockMatchesRvo;
        this.disabled = false;
        this.store.dispatch(setInitialStockMatchesRvo({ initialStockMatchesRvo }));
      });
  }
}
